import React from 'react';
import { useSetRecoilState } from 'recoil';
import { overlayProppress } from '../../atoms/OverlayProgress';
import { flashMessageSuccess, flashMessageError } from '../../atoms/FlashMessage';
import { zshDialog } from '../../atoms/ZshDialog';
import { RouteComponentProps } from 'react-router-dom';
import DataTable, { DataTableRowsProps, DataTableBtnGroupProps } from '../../components/View/DataTable';
import { searchFilterProps } from '../../components/View/SearchFilter';
import * as _data_actions from '../../helper/dataActions';

function InflowSourceMastersIndex({ history, location }: RouteComponentProps) {

  const setOverlayProppress = useSetRecoilState(overlayProppress);
  const setFlashMessageSuccess = useSetRecoilState(flashMessageSuccess);
  const setFlashMessageError = useSetRecoilState(flashMessageError);
  const setZshDialog = useSetRecoilState(zshDialog);

  const clickCell = (callbackParams: any) => {
    history.push(location.pathname + '/' + callbackParams.data.id);
  }

  const handleToAdd = () => {
    history.push('/inflow-source-masters/add');
  }

  const confirmDelete = (params: any) => {
    if (params.selected.length > 0) {
      _data_actions.showConfirmDialog({
        dialogType: 'delete',
        funcAgree: () => {
          handleDelete(params);
        },
        setZshDialog
      });
    } else {
      setFlashMessageError('項目を選択してください');
    }
  }

  const handleDelete = (params: any) => {
    _data_actions.deleteData({
      deleteUrl: 'inflow-source-masters/delete/',
      selected: params.selected,
      getData: params.getData,
      setOverlayProppress,
      setFlashMessageSuccess,
      setFlashMessageError
    });
  }

  const rows: DataTableRowsProps[] = [
    {
      label: 'ID',
      value: 'id',
      sortField: 'InflowSourceMasters.id',
      align: 'left',
    },
    {
      label: '流入元区分',
      value: 'inflow_source_type_name',
      align: 'left'
    },
    {
      label: '流入元名',
      value: 'name',
      sortField: 'InflowSourceMasters.name',
      align: 'left',
    },
    {
      label: '登録日時',
      value: 'created',
      filter: 'YMDHm',
      sortField: 'InflowSourceMasters.created',
      align: 'left',
    },
    {
      label: '更新日時',
      value: 'modified',
      filter: 'YMDHm',
      sortField: 'InflowSourceMasters.modified',
      align: 'left',
    },
  ];

  const searchProps: searchFilterProps[] = [
    {
      key: 'inflow_source_type_id',
      dataKey: 'inflow_source_types',
      title: '流入元区分',
      type: 'select',
      getOptionUrl: 'inflow-source-masters/get-inflow-source-types/index.json',
      optionValue: 'id',
      optionText: 'name',
    },
  ];

  const btnGroup: DataTableBtnGroupProps[] = [
    {
      title: '新規追加',
      func: handleToAdd,
      color: 'primary',
      role: {
        name: 'InflowSourceMasters',
        action: 'add',
      },
    },
    {
      title: '削除',
      func: confirmDelete,
      color: 'default',
      role: {
        name: 'InflowSourceMasters',
        action: 'delete',
      },
    },
  ];

  return (
    <div className="content-1">
      <DataTable
        rows={rows}
        checkbox={true}
        dataKey='inflowSourceMasters'
        jsonPath='inflow-source-masters/index/index.json'
        urlQuery={true}
        parentProps={{ history, location }}
        handleClickCell={clickCell}
        searchProps={searchProps}
        btnGroup={btnGroup}
      />
    </div>
  )
}

export default InflowSourceMastersIndex;